import {
  IMeterClassificationRequest,
  IPropertyCoverage,
  IPropertyMeterContract,
  IPropertyMetersContract,
} from "../contracts/Meter";
import { getDataAsync, putDataAsync } from "../ZeosApiExecutor";
import { IMeter } from "./interfaces/IMeter";

// The meter endpoints share the Property route prefix (MeterController).
const prefix = "/Property/";

export const Meter: IMeter = {
  getPropertyMetersAsync: async (propertyId: number) => {
    const response = await getDataAsync<IPropertyMetersContract>(
      `${prefix}${propertyId}/meters`,
      ""
    );
    return response;
  },
  getPropertyCoverageAsync: async (propertyId: number) => {
    const response = await getDataAsync<IPropertyCoverage>(
      `${prefix}${propertyId}/coverage`,
      ""
    );
    return response;
  },
  classifyMeterAsync: async (
    propertyId: number,
    meterId: number,
    request: IMeterClassificationRequest
  ) => {
    const response = await putDataAsync<IPropertyMeterContract>(
      `${prefix}${propertyId}/meters/${meterId}`,
      request
    );
    return response;
  },
  getManageablePropertyIdsAsync: async (companyId: number) => {
    const response = await getDataAsync<number[]>(
      `${prefix}meters/manageable?companyId=${companyId}`,
      ""
    );
    return response;
  },
};
